import { createAction } from '@reduxjs/toolkit';
import { Action } from 'redux';
import {
    IGetCompanyDetails,
    ICreateCompany,
    IUpdateCompany,
    IAddCompanyReview,
    IEditCompanyReview,
    ILikeCompanyReview,
    IDeleteCompanyReview,
    ICompanyDetails,
    ICompany,
    ICompanyReview,
    types,
    ISearchCompaniesResponse,
    ICreatePosition,
    IApprovePosition,
    IDeletePosition,
    IPosition,
} from './types';
import { IErrorType } from '../../constants/types';
import { IGenericDocumentModifier } from '../../types/global/helper';

// Company actions
export const getCompanyDetails = createAction<IGetCompanyDetails>(types.GET_COMPANY_DETAILS);
export const getCompanyDetailsSuccess = createAction<{ data: ICompanyDetails; singleFetch?: boolean }>(
    types.GET_COMPANY_DETAILS_SUCCESS,
);
export const getCompanyDetailsFail = createAction<IErrorType>(types.GET_COMPANY_DETAILS_FAIL);

export const createCompany = createAction<ICreateCompany>(types.CREATE_COMPANY);
export const createCompanySuccess = createAction<ICompany>(types.CREATE_COMPANY_SUCCESS);
export const createCompanyFail = createAction<IErrorType>(types.CREATE_COMPANY_FAIL);

export const updateCompany = createAction<IUpdateCompany>(types.UPDATE_COMPANY);
export const updateCompanySuccess = createAction<ICompany>(types.UPDATE_COMPANY_SUCCESS);
export const updateCompanyFail = createAction<IErrorType>(types.UPDATE_COMPANY_FAIL);

export const deleteCompany = createAction<string>(types.DELETE_COMPANY);
export const deleteCompanySuccess = createAction<string>(types.DELETE_COMPANY_SUCCESS);
export const deleteCompanyFail = createAction<IErrorType>(types.DELETE_COMPANY_FAIL);

// Company review actions
export const addCompanyReview = createAction<IAddCompanyReview>(types.ADD_COMPANY_REVIEW);
export const addCompanyReviewSuccess = createAction<ICompanyReview>(types.ADD_COMPANY_REVIEW_SUCCESS);
export const addCompanyReviewFail = createAction<IErrorType>(types.ADD_COMPANY_REVIEW_FAIL);

export const editCompanyReview = createAction<IEditCompanyReview>(types.EDIT_COMPANY_REVIEW);
export const editCompanyReviewSuccess = createAction<ICompanyReview>(types.EDIT_COMPANY_REVIEW_SUCCESS);
export const editCompanyReviewFail = createAction<IErrorType>(types.EDIT_COMPANY_REVIEW_FAIL);

export const likeCompanyReview = createAction<ILikeCompanyReview>(types.LIKE_COMPANY_REVIEW);
export const likeCompanyReviewSuccess = createAction<ICompanyReview>(types.LIKE_COMPANY_REVIEW_SUCCESS);
export const likeCompanyReviewFail = createAction<IErrorType>(types.LIKE_COMPANY_REVIEW_FAIL);

export const deleteCompanyReview = createAction<IDeleteCompanyReview>(types.DELETE_COMPANY_REVIEW);
export const deleteCompanyReviewSuccess = createAction<string>(types.DELETE_COMPANY_REVIEW_SUCCESS);
export const deleteCompanyReviewFail = createAction<IErrorType>(types.DELETE_COMPANY_REVIEW_FAIL);

export const deleteCompanyReviewLike = createAction<IGenericDocumentModifier>(types.DELETE_COMPANY_REVIEW_LIKE);
export const deleteCompanyReviewLikeSuccess = createAction<IGenericDocumentModifier>(
    types.DELETE_COMPANY_REVIEW_LIKE_SUCCESS,
);
export const deleteCompanyReviewLikeFail = createAction<IErrorType>(types.DELETE_COMPANY_REVIEW_LIKE_FAIL);

// Position management actions
export const createPosition = createAction<ICreatePosition>(types.CREATE_POSITION);
export const createPositionSuccess = createAction<IPosition>(types.CREATE_POSITION_SUCCESS);
export const createPositionFail = createAction<IErrorType>(types.CREATE_POSITION_FAIL);

export const approvePosition = createAction<IApprovePosition>(types.APPROVE_POSITION);
export const approvePositionSuccess = createAction<IPosition>(types.APPROVE_POSITION_SUCCESS);
export const approvePositionFail = createAction<IErrorType>(types.APPROVE_POSITION_FAIL);

export const deletePosition = createAction<IDeletePosition>(types.DELETE_POSITION);
export const deletePositionSuccess = createAction<IDeletePosition>(types.DELETE_POSITION_SUCCESS);
export const deletePositionFail = createAction<IErrorType>(types.DELETE_POSITION_FAIL);

// Action types for TypeScript
export interface GetCompanyDetailsAction extends Action, IGetCompanyDetails {
    type: typeof types.GET_COMPANY_DETAILS;
}

export interface CreateCompanyAction extends Action, ICreateCompany {
    type: typeof types.CREATE_COMPANY;
}

export interface UpdateCompanyAction extends Action, IUpdateCompany {
    type: typeof types.UPDATE_COMPANY;
}

export interface DeleteCompanyAction extends Action {
    type: typeof types.DELETE_COMPANY;
    payload: string;
}

export interface AddCompanyReviewAction extends Action, IAddCompanyReview {
    type: typeof types.ADD_COMPANY_REVIEW;
}

export interface EditCompanyReviewAction extends Action, IEditCompanyReview {
    type: typeof types.EDIT_COMPANY_REVIEW;
}

export interface LikeCompanyReviewAction extends Action, ILikeCompanyReview {
    type: typeof types.LIKE_COMPANY_REVIEW;
}

export interface DeleteCompanyReviewAction extends Action, IDeleteCompanyReview {
    type: typeof types.DELETE_COMPANY_REVIEW;
}

export const searchCompanies = createAction<{ searchTerm: string }>(types.SEARCH_COMPANIES);

export const searchCompaniesSuccess = createAction<ISearchCompaniesResponse>(types.SEARCH_COMPANIES_SUCCESS);

export const searchCompaniesFail = createAction<IErrorType>(types.SEARCH_COMPANIES_FAIL);
